'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseUserProfileController=require('./baseUserProfileController');
const LoginModalConfig=require('../../../../../../dist-es6/client/features/login/modals/loginModalConfig');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

UserProfileDirective=class UserProfileDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/features/profile/components/userProfile/userProfileView';
}

get controller(){
return UserProfileController;
}};let


UserProfileController=(_class=class UserProfileController extends BaseUserProfileController{
static get $inject(){
return['$timeout','$modal','userService','uncaughtErrorHandler'];
}

constructor($timeout,$modal,userService,uncaughtErrorHandler){
super(uncaughtErrorHandler,userService.currentUser);
this._$timeout=$timeout;
this._$modal=$modal;
this._userService=userService;

this._forceReloadOfUserInfo();
}


async _forceReloadOfUserInfo(){
await this._userService.continueUserSession();
this._reloadInfoFromUserService();
}

_reloadInfoFromUserService(){
this._$timeout(()=>{

if(_.exists(this._userService.currentUser)){
this._firstName=this._userService.currentUser.firstName;
this._lastName=this._userService.currentUser.lastName;
this._phone=this._userService.currentUser.phone;
this._email=this._userService.currentUser.email;
}
});
}

editUser(){
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/profile/components/userProfile/editUserModalView',
controller:'EditUserModalController as controller',
resolve:{
user:()=>this,
onUserUpdated:()=>this._reloadInfoFromUserService.bind(this)}});


}

changePassword(){
let changePasswordModalInstance=this._$modal.open({
templateUrl:'/templates/features/profile/components/userProfile/changeUserPasswordModalView',
controller:'ChangeUserPasswordModalController as controller'});

changePasswordModalInstance.result.then(()=>{
let modalConfigWithPasswordChangedText=_.defaultsDeep({resolve:{reason:()=>'PasswordChanged'}},LoginModalConfig);
let loginModalInstance=this._$modal.open(modalConfigWithPasswordChangedText);
});
}

get hideProfileEditButton(){
return _.exists(this._userService,'currentUser.authConfigName');
}},(_applyDecoratedDescriptor(_class.prototype,'_forceReloadOfUserInfo',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_forceReloadOfUserInfo'),_class.prototype)),_class);


module.exports=UserProfileDirective;
//# sourceMappingURL=userProfileDirective.js.map
